/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Resource context
 *
 * @file ResourceContext.js
 * @author Sam George
 * @since 1.0.0
 */

import { Children, Component } from 'react';
import PropTypes from 'prop-types';

import ResourceEmitter from './ResourceEmitter';

class ResourceContext extends Component {
  constructor(s, c) {
    super(s, c);
    this.resourceContext = new ResourceEmitter(this.props);
  }

  getChildContext() {
    return {
      resourceContext: this.resourceContext
    };
  }

  componentDidUpdate() {
    this.resourceContext.setValue(this.props);
  }

  render() {
    return Children.only(this.props.children);
  }
}

ResourceContext.childContextTypes = {
  resourceContext: PropTypes.object.isRequired
};

ResourceContext.propTypes = '';

export default ResourceContext;
